/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ion-page[_ngcontent-%COMP%]{display:-webkit-flex!important;display:flex!important;-webkit-justify-content:center!important;justify-content:center!important;-webkit-align-items:center!important;align-items:center!important;--background:none!important}.div-btn-close[_ngcontent-%COMP%]{display:-webkit-flex;display:flex;-webkit-justify-content:center;justify-content:center;font-size:2.5rem;margin:1rem;color:#fff}"];
export { styles as styles };
